module.exports = __webpack_public_path__ + "img/017.adc2f72d.png";